import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { fi } from 'date-fns/locale';

@Component({
  selector: 'app-requests-credits',
  templateUrl: './requests-credits.component.html',
  styleUrls: ['./requests-credits.component.scss']
})
export class RequestsCreditsComponent {
  // Grupos de formulario para cada sección
  personalDataFormGroup!: FormGroup;
  employmentDataFormGroup!: FormGroup;
  financialDataFormGroup!: FormGroup;
  contactDataFormGroup!: FormGroup;
  referencialDataFormGroup!: FormGroup;
  paymnetDataFormGroup!: FormGroup;

  // Array para manejar las pestañas
  tabs = [
    { label: 'Datos Personales', icon: '👤', formGroup: 'personalDataFormGroup' },
    { label: 'Información Laboral', icon: '💼', formGroup: 'employmentDataFormGroup' },
    { label: 'Información Financiera', icon: '💰', formGroup: 'financialDataFormGroup' },
    { label: 'Información de Contacto', icon: '📍', formGroup: 'contactDataFormGroup' },
    { label: 'Información de Referencia', icon: '📍', formGroup: 'referencialDataFormGroup' },
    { label: 'Información de Desembolso', icon: '📍', formGroup: 'paymnetDataFormGroup' }
  ];
  currentTabIndex = 0; // Índice de la pestaña activa

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    // Inicialización de los FormGroup con validadores
    this.personalDataFormGroup = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      documentType: ['cedula', Validators.required],
      documentNumber: ['', Validators.required],
      birthDate: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required]
    });

    this.employmentDataFormGroup = this.fb.group({
      companyName: ['', Validators.required],
      position: ['', Validators.required],
      seniority: ['', [Validators.required, Validators.min(0)]],
      monthlySalary: ['', [Validators.required, Validators.min(0)]]
    });

    this.financialDataFormGroup = this.fb.group({
      additionalIncome: ['', [Validators.min(0)]],
      monthlyExpenses: ['', [Validators.required, Validators.min(0)]],
      creditAmountRequested: ['', [Validators.required, Validators.min(0)]],
      termMonths: ['', [Validators.required, Validators.min(1)]]
    });

    this.contactDataFormGroup = this.fb.group({
      address: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      personalReference1Name: ['', Validators.required],
      personalReference1Phone: ['', Validators.required],
      personalReference2Name: [''],
      personalReference2Phone: ['']
    });

    this.referencialDataFormGroup = this.fb.group({
      address: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      personalReference1Name: ['', Validators.required],
      personalReference1Phone: ['', Validators.required],
      personalReference2Name: [''],
      personalReference2Phone: ['']
    });

    this.paymnetDataFormGroup = this.fb.group({
      address: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      personalReference1Name: ['', Validators.required],
      personalReference1Phone: ['', Validators.required],
      personalReference2Name: [''],
      personalReference2Phone: ['']
    });
  }

  // Método para obtener el FormGroup activo
  get currentFormGroup(): FormGroup {
    return (this as any)[this.tabs[this.currentTabIndex].formGroup];
  }

  // Navegación entre pestañas
  goToTab(index: number): void {
    // Opcional: Podrías añadir lógica de validación aquí antes de cambiar de pestaña si es un requisito
    // if (index > this.currentTabIndex && !this.currentFormGroup.valid) {
    //   this.currentFormGroup.markAllAsTouched(); // Marca todos los campos como tocados para mostrar errores
    //   alert('Por favor, completa todos los campos requeridos antes de avanzar.');
    //   return;
    // }
    this.currentTabIndex = index;
  }

  // Navegación siguiente
  nextTab(): void {
    if (this.currentFormGroup.valid) {
      if (this.currentTabIndex < this.tabs.length - 1) {
        this.currentTabIndex++;
      }
    } else {
      this.currentFormGroup.markAllAsTouched(); // Marca todos los campos como tocados para mostrar errores
      alert('Por favor, completa todos los campos requeridos antes de avanzar.');
    }
  }

  // Navegación anterior
  previousTab(): void {
    if (this.currentTabIndex > 0) {
      this.currentTabIndex--;
    }
  }

  // Envío final del formulario
  submitForm(): void {
    // Aquí puedes recopilar todos los datos de los formularios
    const personalData = this.personalDataFormGroup.value;
    const employmentData = this.employmentDataFormGroup.value;
    const financialData = this.financialDataFormGroup.value;
    const contactData = this.contactDataFormGroup.value;
    const referencialData = this.referencialDataFormGroup.value;
    const paymentData = this.paymnetDataFormGroup.value;

    const fullCreditApplication = {
      ...personalData,
      ...employmentData,
      ...financialData,
      ...contactData,
      ...referencialData,
      ...paymentData
    };

    if (this.personalDataFormGroup.valid &&
        this.employmentDataFormGroup.valid &&
        this.financialDataFormGroup.valid &&
        this.contactDataFormGroup.valid &&
        this.referencialDataFormGroup.valid &&
        this.paymnetDataFormGroup.valid
      ) {
      //console.log('Datos completos de la solicitud de crédito:', fullCreditApplication);
      // Aquí iría la lógica para enviar los datos al backend (ej. un servicio HTTP)
      //alert('¡Solicitud de crédito enviada con éxito! (Simulado)');
      // Opcional: Resetear formularios o redirigir
      // this.personalDataFormGroup.reset();
      // this.employmentDataFormGroup.reset();
      // this.financialDataFormGroup.reset();
      // this.contactDataFormGroup.reset();
      // this.currentTabIndex = 0;
    } else {
      // Si el formulario no es válido, marca todos los campos como tocados para mostrar los errores
      this.personalDataFormGroup.markAllAsTouched();
      this.employmentDataFormGroup.markAllAsTouched();
      this.financialDataFormGroup.markAllAsTouched();
      this.contactDataFormGroup.markAllAsTouched();
      this.referencialDataFormGroup.markAllAsTouched();
      this.paymnetDataFormGroup.markAllAsTouched();
      alert('Por favor, corrige los errores en el formulario antes de enviarlo.');
    }
  }

  
}
